export enum SurveysAnalysisChartGroupBy {
  Day = 0,
  Week = 1,
  Month = 2,
  Quarter = 3,
  Year = 4,
}

export enum SurveyDeliveryMethod {
  SharableLink,
  Email,
  Either,
}

export enum SurveyImagePosition {
  Left,
  Centre,
  Right,
}

export enum SurveySectionType {
  IndividualQuestion,
  RadioButtonMatrix,
  QuestionGroup,
  AcelQuestion,
  AcelNumDaysTravelToWork,
  AcelNumDaysWorkFromHome,
  AcelDistanceToWork,
  QuestionSection,
}


export enum SurveyQuestionType {
  None = -1,
  NumberRating = 0,
  SingleText = 1,
  Comment = 2,
  MultipleChoiceCheckbox = 3,
  MultipleChoiceRadio = 4,
  EmailAddress = 5,
  Dropdown = 6,
  Location = 7,
  Acel = 8,
  MultiQuestion = 9,
  Number = 10,
  Distance = 11,
  DaysPerWeek = 12,
}

export enum SurveyStatus {
  Draft = 0,
  Published = 1,
  Unpublished = 2,
}
